import { Badge, Box } from '@mantine/core';
import type { BadgeProps } from '@mantine/core';
import { getGroupAvatarColor } from '../../utils/groupColors';
import classes from './GroupBadge.module.css';

export interface GroupBadgeProps {
  /** Group name to display. When null/undefined, renders "Unassigned" badge. */
  groupName?: string | null;
  /** Group ID used for deterministic dot color. Required when groupName is set. */
  groupId?: string | null;
  /** Mantine Badge size prop. Defaults to "sm". */
  size?: BadgeProps['size'];
}

/**
 * Shared group label pill with a deterministic colored dot.
 *
 * Assigned:   green "light" badge with a hash-colored dot
 * Unassigned: yellow "light" badge with a currentColor dot
 */
export function GroupBadge({ groupName, groupId, size = 'sm' }: GroupBadgeProps) {
  if (!groupName || !groupId) {
    return (
      <Badge
        variant="light"
        color="yellow"
        size={size}
        tt="none"
        leftSection={<Box className={classes.groupDot} />}
      >
        Unassigned
      </Badge>
    );
  }

  const dotColor = getGroupAvatarColor(groupName, groupId);

  return (
    <Badge
      variant="light"
      color="medleyGreen"
      size={size}
      tt="none"
      leftSection={
        <Box className={classes.groupDot} style={{ backgroundColor: dotColor }} />
      }
    >
      {groupName}
    </Badge>
  );
}
